import { clientsInstance } from "../axios";

export const getApps = async () => {
  let response = null;
  try {
    response = await clientsInstance.get("/promoters-apps");
  } catch (e) {}
  return response;
};
